import React, { useMemo } from 'react'
import { defineMessages, FormattedMessage, MessageDescriptor } from 'react-intl'

import { ClientFiltersRadioSection } from './ClientFiltersRadioSection'

export enum ClientFilterStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export type ClientFiltersStatusSectionProps = {
  value: ClientFilterStatus
  onChange: (values: ClientFilterStatus) => void
}

export const ClientFiltersStatusSection: React.FC<ClientFiltersStatusSectionProps> = ({ value, onChange }) => {
  const filterNames: Record<ClientFilterStatus, MessageDescriptor> = useMemo(
    () =>
      defineMessages({
        [ClientFilterStatus.ACTIVE]: {
          defaultMessage: 'Active',
          description: 'Label for filtering conversations by active status',
        },
        [ClientFilterStatus.INACTIVE]: {
          defaultMessage: 'Inactive',
          description: 'Label for filtering conversations by inactive status',
        },
      }),
    [],
  )

  return (
    <ClientFiltersRadioSection
      title={<FormattedMessage defaultMessage='Status' description='Status filter section' />}
      items={Object.values(ClientFilterStatus).map((value) => ({
        id: value,
        text: <FormattedMessage {...filterNames[value]} />,
      }))}
      value={value}
      onChange={onChange}
      name='status'
    />
  )
}
